import React from "react"
import { TextField, Grid } from "@mui/material"
import PropTypes from "prop-types"
import i18n from "i18n"

const NotesTab = ({ fields, handleChange }) => {
  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      <Grid item xs={12}>
        <TextField
          label={i18n.t("contacts.notes")}
          name="notes"
          value={fields.notes || ""}
          onChange={handleChange}
          fullWidth
          multiline
          rows={4}
        />
      </Grid>
    </Grid>
  )
}

NotesTab.propTypes = {
  fields: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
}

export default NotesTab
